export default __webpack_public_path__ + "02abf0068b8ad284811503ea2ce0da11.svg";